import { render, staticRenderFns } from "./Vite.vue?vue&type=template&id=457af82c&"
import script from "./Vite.vue?vue&type=script&lang=js&"
export * from "./Vite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports